module.exports = __webpack_public_path__ + "static/media/linkedin-black.adc79e99.svg";